import React, { useEffect, useState } from "react";
import styled from "styled-components";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";
import bgImage from "../assets/images/HEADER-bg.png";
import "../styles/home.css";
import { Spring } from "react-spring";
import ReactGA from 'react-ga';

const VERSIONS_TYPES = {
    current: "CURRENT",
    versionA: "VERSION_A",
    versionB: "VERSION_B"
}

// Here is the Verion object::
//  Current = VERSIONS_TYPES.current,  (with ICO progress section)
//  Version_A = VERSIONS_TYPES.versionA  (youtube video without ICO progress)
//  Version_B = VERSIONS_TYPES.versionB  ( youtube video and ICO progress section below)

const VERSION = VERSIONS_TYPES.versionA

// Here is the Link of YouTube Video
const VIDEO_LINK = "https://www.youtube.com/embed/8TVTrtFQ5-4"


function Home() {
    const { width, height } = useWindowDimensions();
    const [value, setValue] = useState(0);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        ReactGA.pageview(window.location.pathname);
        setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
    }, []);

    function setSliderBackground(target) {
        // Add your background logic here:
        if (target.value === value) {
            target.style.background = colors.btnPrimary;
        } else {
            target.style.background = colors.grey;
        }
    }

    // Bind the event handler to all of the sliders with the slider class:
    for (let slider of document.querySelectorAll(".slider")) {
        slider.addEventListener("change", event => setSliderBackground(event.target));
        // Set the background once on initial load so it is correct before the user interacts:
        setSliderBackground(slider);
    }

    return (
        <Container width={width} height={height}>
            <InnerContainer width={width} height={height}>
                <MainHeading>
                    "ZERO" COST & CODE BLOCKCHAIN APP BUILDER FOR TRANSPARENT SUPPLY CHAIN
                </MainHeading>
                <SubHeading>
                    {/* GearChain solves the last mile problem by connecting supply chain to blockchain. */}
                    GearChain aims to revolutionize the inventory and supply chain industry by using zero-code blockchain app builder with fast, affordable, and reliable network and decentralized apps.
                </SubHeading>
                <BtnContainer>
                    <Btn >
                        <a href="https://forms.gle/KS1wHrQ5TQWcC8JL7" rel="noreferrer" target="_blank"
                            style={{ textDecoration: "none", color: colors.white }}
                        >
                            Whitelist Request
                        </a>
                    </Btn>
                    <VideoButton>

                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdBLxNiTv3O949-7XE7HLQ6Lcq-QJ53boXQjDwTdyZ5pC-4Fw/viewform?usp=send_form"
                            style={{ textDecoration: "none", color: colors.white }}
                        >
                            Join Beta Tester
                        </a>
                    </VideoButton>
                </BtnContainer>
            </InnerContainer>
            {(VERSION === VERSIONS_TYPES.versionA || VERSION === VERSIONS_TYPES.versionB) &&
                // This is YouTube Video Code
                (<div className="video-responsive">
                    <iframe width="917" height="516" src={`${VIDEO_LINK}?rel=0`} title="Introduction to GearChain" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen="allowfullscreen" ></iframe>
                </div>)}
            {(VERSION === VERSIONS_TYPES.current || VERSION === VERSIONS_TYPES.versionB) &&
                // This is ICO bar Code
                (<ContainerBox height={height}>
                    <div style={{}}>
                        <FloatContainer width={width} height={height} style={{ justifyContent: "space-between", marginTop: -height * 0.13 }}>
                            <div style={{ marginLeft: -30 }}>
                                <PointsText style={{ fontSize: 10, textAlign: "center" }}>RAISED</PointsText>
                                <PointsText style={{ fontSize: 16, margin: 0, fontWeight: "bold", textAlign: "center" }}>0 GEAR</PointsText>
                            </div>
                            <div style={{ marginRight: -80 }}>
                                <PointsText style={{ fontSize: 10, textAlign: "center" }}>TOTAL</PointsText>
                                <PointsText style={{ fontSize: 16, margin: 0, fontWeight: "bold", textAlign: "center" }}>10B GEAR</PointsText>
                                <PointsText style={{ fontSize: 16, margin: 0, fontWeight: "bold", textAlign: "center" }}>2,000,000,000 GEAR</PointsText>
                            </div>
                        </FloatContainer>
                        <FloatContainer width={width} style={{ zIndex: 1, marginTop: -height * 0.03 }}>
                            <RightBorder />
                            <RightBorder />
                            <RightBorder />
                        </FloatContainer>
                        <BottomContainer height={height}>
                            <Spring
                                from={{ x: 0 }}
                                to={{ x: 1000 }}
                                config={{ duration: 5000 }}
                            >
                                {props => (
                                    // <LinearProgressWithLabel value={progress} width={width} />
                                    <input type="range" onChange={(val) => setValue(val.target.value)} value={value} step={1} min="0" max="100" class="slider" />
                                )}
                            </Spring>
                        </BottomContainer>
                        <FloatContainer width={width} height={height} style={{ marginTop: 25 }}>
                            <div style={{ marginLeft: -50 }}>
                                <PointsText style={{ fontSize: 10, margin: 0, textAlign: "center" }}>START PRIVATE SALE</PointsText>
                                <PointsText style={{ fontSize: 10, margin: 0, textAlign: "center" }}>500,000,000</PointsText>
                            </div>
                            <div >
                                <PointsText style={{ fontSize: 10, margin: 0, textAlign: "center" }}>START PRESALE</PointsText>
                                <PointsText style={{ fontSize: 10, margin: 0, textAlign: "center" }}>500,000,000</PointsText>
                            </div>
                            <div style={{ marginRight: -50 }}>
                                <PointsText style={{ fontSize: 10, margin: 0, textAlign: "center" }}>START PUBLIC SALE</PointsText>
                                <PointsText style={{ fontSize: 10, margin: 0, textAlign: "center" }}>1,000,000,000</PointsText>
                            </div>
                        </FloatContainer>
                    </div>
                    <ContainerInnerBox height={height}>
                        <p style={{ margin: 0 }}>NEXT ROUND</p>
                        <p style={{ color: colors.btnPrimary, fontSize: 28, margin: 0 }}>Private Sale</p>
                        <p style={{ margin: 0 }}>Only With Access</p>
                    </ContainerInnerBox>
                </ContainerBox>)}



        </Container>
    );
}

const Container = styled.div`
                background-image: url(${bgImage});
                padding-left: ${({ width }) => width * 0.1}px;
                padding-right: ${({ width }) => width * 0.1}px;
                padding-bottom: 50px;
                `

const InnerContainer = styled.div`
                display: flex;
                flex-direction: column;
                margin-top: ${({ height }) => height * 0.1}px ;
                color: ${colors.white};
                width: ${({ width }) => width / 2}px;

                @media (max-width: 768px) {
                    width: ${({ width }) => width / 1.3}px;
    }
                `
const MainHeading = styled.p`
                font-size: 35px;
                margin-bottom: 0px;
                `

const SubHeading = styled.p`
                font-size: 18px;
                `

const BtnContainer = styled.div`
                display: flex;
                margin-top: 20px;
                `

const Btn = styled.button`
                border: 0px;
                background-color: ${colors.btnPrimary};
                color: ${colors.white};
                padding: 10px 20px;
                border-radius: 5px;
                `

const PointsText = styled.p`
                color: ${colors.white};
                `

const VideoButton = styled(Btn)`
                background-color: transparent;
                border: 1px solid ${colors.btnPrimary};
                color: ${colors.btnPrimary};
                margin-left: 30px;
                `

const BottomContainer = styled.div`
                display: flex;
                `

const FloatContainer = styled.div`
                position: absolute;
                display: flex;
                width: ${({ width }) => width / 2}px;
                justify-content: space-between;
                color: ${colors.white};
                margin: 0px 100px;
                @media (max-width: 768px) {
                    margin: 0px 50px;
    }
                `

const RightBorder = styled.div`
                border-right: 1px solid #fff;
                height: 50px;
                padding: 0px;

                `

const ContainerBox = styled.div`
                display: "flex";
                flex-direction: row;
                margin-top: ${({ height }) => height * 0.25}px;
                margin-bottom: ${({ height }) => height * 0.1}px;

                @media (max-width: 768px) {
                    display: block;

    }
                `

const ContainerInnerBox = styled.div`
                margin: 0px;
                padding: 0px;
                color: ${colors.white};
                float: right;
                margin-top: -${({ height }) => height * 0.06}px;
                margin-right: -50px;
                @media (max-width: 768px) {
                    margin-top: ${({ height }) => height * 0.15}px;
                float: left;
                margin-right: 0px;

    }
                `

export default Home;
